<template>
    <div>
      <!-- Exibe o LoadingSpinner enquanto isLoading for true -->
      <div v-if="isLoading">
        <LoadingSpinner />
      </div>
      <!-- Quando não estiver carregando, exibe o conteúdo -->
      <div v-else>
        <div v-if="formularioData" class="card card-body shadow-sm mt-0">
          <div class="header d-flex justify-content-between align-items-center">
            <h4 class="form-title">
              Detalhes do Formulário de Avaliação:
              <span v-if="formularioData.id">{{ formularioData.id }}</span>
            </h4>
            <button class="btn btn-secondary" @click="voltar">Voltar</button>
          </div>
  
          <!-- Seção 1: Dados do Formulário -->
          <div class="form-content mt-3">
            <FormSection title="Dados do Formulário">
              <p><strong>Nome do Formulário:</strong> {{ formularioData.formulario }}</p>
            </FormSection>
          </div>
  
          <!-- Seção 2: Questões -->
          <div class="form-content mt-3">
            <FormSection title="Questões">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Categoria</th>
                    <th>Bloco</th>
                    <th>Questão</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(questao, index) in formularioData.questoes" :key="questao.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ questao.categoria }}</td>
                    <td>{{ questao.bloco }}</td>
                    <td>{{ questao.questao }}</td>
                  </tr>
                  <tr v-if="formularioData.questoes.length === 0">
                    <td colspan="4" class="text-center">Nenhuma questão registrada.</td>
                  </tr>
                </tbody>
              </table>
            </FormSection>
          </div>
        </div>
        <div v-else>
          <p>Nenhum formulário encontrado.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import axios from '@/services/axios';
  import FormSection from '@/components/Layout/FormSection.vue';
//   import LoadingSpinner from '@/components/LoadingSpinner.vue';
  
  export default {
    name: 'DetalharFormularioAvaliacao',
    components: { 
      FormSection, 
    //   LoadingSpinner 
    },
    setup() {
      const route = useRoute();
      const router = useRouter();
      const isLoading = ref(true);
      const formularioData = ref(null);
  
      const carregarFormulario = async (id) => {
        try {
          // O endpoint deve retornar um objeto contendo:
          // { id, formulario, questoes: [{ id, categoria, bloco, questao }, ...] }
          const response = await axios.get(`/configuracoes/formularios-avaliacoes/${id}`);
          formularioData.value = response.data;
        } catch (error) {
          console.error("Erro ao carregar formulário:", error);
        } finally {
          isLoading.value = false;
        }
      };
  
      const voltar = () => {
        router.push('/configuracoes/formularios-avaliacoes');
      };
  
      onMounted(() => {
        if (route.params.id) {
          carregarFormulario(route.params.id);
        } else {
          isLoading.value = false;
        }
      });
  
      return { isLoading, formularioData, voltar };
    }
  };
  </script>
  
  <style scoped>
  .card {
    margin: 20px;
  }
  .form-title {
    font-size: 1.25rem;
    font-weight: bold;
  }
  </style>
  